"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = exports.lett = exports.d = exports.deepSet = exports.deepGet = exports.uuid = void 0;
__exportStar(require("./hooks"), exports);
function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
exports.uuid = uuid;
function deepGet(obj, property, defaultValue) {
    if (!obj)
        return defaultValue;
    if (/\./g.test(property)) {
        const properties = property.split('.');
        return deepGet(obj[properties[0]], properties.slice(1).join('.'), defaultValue);
    }
    else {
        return [undefined, null].indexOf(obj[property]) === -1
            ? obj[property]
            : defaultValue;
    }
}
exports.deepGet = deepGet;
function deepSet(obj, property, value) {
    if (/\./g.test(property)) {
        const properties = property.split('.');
        if (!obj[properties[0]]) {
            obj[properties[0]] = {};
        }
        deepSet(obj[properties[0]], properties.slice(1).join('.'), value);
    }
    else {
        obj[property] = value;
    }
}
exports.deepSet = deepSet;
function d(value, marker = ' ') {
    if (typeof value === 'function') {
        return function (...args) {
            const res = value(...args);
            console.log(marker, args, res);
            return res;
        };
    }
    else {
        console.log(marker, value);
        return value;
    }
}
exports.d = d;
function lett(value, closure) {
    if (value === undefined || value === null)
        return value;
    return closure(value);
}
exports.lett = lett;
function debounce(callback, time) {
    let interval;
    return (...args) => {
        interval && clearTimeout(interval);
        interval = setTimeout(() => {
            interval = null;
            callback(...args);
        }, time);
    };
}
exports.debounce = debounce;
//# sourceMappingURL=index.js.map